import React from 'react'
import "./PrivacyPolicy.css"
import { InnerPageHeader } from '../../components'
import { Container } from "react-bootstrap"
import { useTranslation } from '../../contexts/TranslationContext';


const PrivacyPolicy = ({ pageData }) => {

  const templates = pageData?.content?.templates[0] || [];
  const { t } = useTranslation();

 

  return (
    <div>
        <InnerPageHeader
            title= {t("PrivacyPolicy")}
        />
        <Container>

          <div className='inner-pages-para'>
              {templates.data?.privacy_policy && (
                <div
                  className="prose"
                  dangerouslySetInnerHTML={{
                    __html: templates.data.privacy_policy,
                  }}
                />
              )}
          </div>
       
        </Container>
    </div>
  )
}

export default PrivacyPolicy